import { ReadonlyURLSearchParams } from 'next/navigation'

interface AppendUrlParamsProps {
  link: string
  searchParams: ReadonlyURLSearchParams | URLSearchParams
}

export const appendUrlParams = ({
  link,
  searchParams,
}: AppendUrlParamsProps) => {
  try {
    const parsedUrl = new URL(link)
    const allowedHosts = ['marshall.co.uk', 'www.marshall.co.uk']
    if (allowedHosts.includes(parsedUrl.hostname)) {
      return searchParams.toString()
        ? `${link}?${searchParams.toString()}`
        : link
    }

    return link
  } catch {
    return link
  }
}
